import(/* webpackMode: "eager", webpackExports: ["MarketplacePage"] */ "/vercel/path0/components/marketplace/MarketplacePage.tsx");
